import React from 'react';

// Import the Accordion components from MUI
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import { styled } from '@mui/material/styles';

import Flex from 'ui/Flex/Flex';
import { Box } from '@mui/system';

const StyAccordionTitle = styled(Typography, { name: 'StyAccordionTitle' })(
    () => ({
        fontSize: '14px',
        fontWeight: 700,
        marginRight: '16px',
        color: '#FFF',
    }),
);

const StyChip = styled(Chip, { name: 'StyChip' })(() => ({
    borderRadius: '28px',
    border: '1px solid #FFF',
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    color: '#FFF',
    height: '26px',
}));

type Props = {
    title: string;
    extraElement?: React.ReactNode;
    chip?: string;
    children: React.ReactElement;
};

/**
 * Accordion component used to wrapped AgGrid TCD in PRH.
 */
const TCDAccordion = ({ title, chip, extraElement, children }: Props) => {
    return (
        <Flex direction="column" height="100%">
            <Box
                sx={{
                    backgroundColor: 'primary.main',
                    borderRadius: '8px',
                    padding: '1rem',
                }}
            >
                <Flex alignItems="center" flexGrow={1}>
                    <StyAccordionTitle>{title}</StyAccordionTitle>
                    {chip && <StyChip variant="outlined" label={chip} />}
                    {extraElement}
                </Flex>
            </Box>
            <Box sx={{ height: '100%', marginTop: '16px' }}>{children}</Box>
        </Flex>
    );
};

export default TCDAccordion;
